/**
 * globalMenu
 */
export function globalMenuToggle() {
	const hamburger = document.querySelector('.l-header__menuToggle');
	const active = 'js-open';
	const noScroll = 'js-noScroll';

	const toggle = (ev) => {
		ev.preventDefault();
		hamburger.classList.toggle(active);
		document.body.classList.toggle(noScroll)

	};

	const close = (ev) => {
		ev.preventDefault();
		hamburger.classList.remove(active);
		document.body.classList.remove(noScroll)

	};

	hamburger.addEventListener('click', toggle);
}